(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SupplierCouponDialogController', SupplierCouponDialogController);

    SupplierCouponDialogController.$inject = ['$scope', '$state', 'SupplierCoupon', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'CouponCustom', '$mdDialog', '$translatePartialLoader', 'SubscriptionPackageCustom', 'CustomerGroupCustom', '$uibModalInstance', 'SubscriptionPackage'];

    function SupplierCouponDialogController($scope, $state, SupplierCoupon, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, CouponCustom, $mdDialog, $translatePartialLoader, SubscriptionPackageCustom, CustomerGroupCustom, $uibModalInstance, SubscriptionPackage) {

        var vm = this;
        vm.supplierCoupon = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;
        vm.allSubscriptionPackages = [];
        vm.switch_changed = switch_changed;
        vm.forAllSubscriptionPackages = true;
        vm.clear = clear;


        initDefault();
        loadAll();

        function initDefault() {
            if (!vm.supplierCoupon.generateType)
                vm.supplierCoupon.generateType = "MANUAL";

            if (!vm.supplierCoupon.status)
                vm.supplierCoupon.status = "ACTIVE";

            if (!vm.supplierCoupon.amountType)
                vm.supplierCoupon.amountType = "PERCENT";
        }

        function loadAll() {
            $translatePartialLoader.addPart('subscriptionPackage');
            $translatePartialLoader.addPart('subscriptionType');
            $translatePartialLoader.addPart('couponGenerateTypes');
            getAllSubscriptionPackages();
        }

        function getAllSubscriptionPackages() {

            SubscriptionPackageCustom.getAllActiveSubscriptionPackages().query().$promise.then(function (result) {
                    vm.allSubscriptionPackages = result;
                    makeSubscriptionPackagesSelectedOnLoad();
                }
            );
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            addSubscriptionPackages();

            if (vm.supplierCoupon.id !== null) {
                SupplierCoupon.update(vm.supplierCoupon, onSaveSuccess, onSaveError);
            } else {

                SupplierCoupon.save(vm.supplierCoupon, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:supplierCouponUpdate', result);
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }

        }

        function switch_changed() {
            if (vm.forAllSubscriptionPackages) {
                angular.forEach(vm.allSubscriptionPackages, function (item) {
                    item.selected = false;
                })

            } else {

            }
        }


        function addSubscriptionPackages() {

            vm.supplierCoupon.subscriptionPackages = [];
            angular.forEach(vm.allSubscriptionPackages, function (item) {

                if (item.selected) {
                    vm.supplierCoupon.subscriptionPackages.push(item);
                }

            })
        }


        function makeSubscriptionPackagesSelectedOnLoad() {

            if (vm.supplierCoupon.subscriptionPackages && vm.supplierCoupon.subscriptionPackages.length > 0) {
                vm.forAllSubscriptionPackages = false;


                angular.forEach(vm.supplierCoupon.subscriptionPackages, function (item) {
                    angular.forEach(vm.allSubscriptionPackages, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }

    }
})();
